var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: this.changeVisibleState,
    once: false
  }),expression:"{\n    callback: this.changeVisibleState,\n    once: false\n  }"}],staticClass:"tooltip-ct"},[_c('span',{staticClass:"trigger"},[_vm._t("default")],2),_c('div',{staticClass:"content"},[_vm._t("tooltip-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }